import * as React from 'react';
import { RegisterPage, ActivateAccountPage, RegisterSucceededPage, ResendSucceededPage } from '../Register';
import { ImprintPage } from './Imprint/Imprint.page';
import { LegalsPage } from './Legals/Legals.page';
import { PrivacyPage } from './Privacy-Policy/Privacy.page';
import { Route, Switch } from 'react-router';
import { ResetPasswordPage } from './Reset-Password/ResetPassword.page';
import { LoginPage } from './Login/Login.page';
import { ResetPasswordChangePage } from './Reset-Password-Change/ResetPasswordChange.page';

import { connect } from 'react-redux';
import { Location } from 'history';

import { IsAuthentificatedState } from 'loopback-react-request';
import { PageNotFound } from '../PageNotFound/PageNotFound';
import { ImageSidebar, RegisterUserTestForm } from 'src/app/Partials';

import { Link } from 'react-router-dom';
import ResetPasswordSucceededPage from './Reset-Password/Succeeded/ResetPasswordSucceeded.page';

import './Home.page.scss';

import { FormattedMessage } from 'react-intl';
import MESSAGES from './Home.messages';
import ChangePasswordSucceededPage from './Change-Password/Succeeded/ChangePasswordSucceeded.page';
import ResetPasswordChangeSucceededPage from './Reset-Password-Change/Succeeded/ResetPasswordChangeSucceeded.page';
import ChangeEmailSucceededPage from './Change-Email/Succeeded/ChangeEmailSucceeded.page';
import TermsModal from 'src/app/Partials/Localize/TermsModal';

export interface HomePageProps {
  authenticator: IsAuthentificatedState;
  location: Location;
}

export interface HomePageState {
  showTerms: boolean; 
}

class HomePageComponent extends React.Component<HomePageProps, HomePageState> {
  constructor(props: HomePageProps) {
    super(props);
    this.state = {
      showTerms: false,
    };
  }

  public render() {
    return (
      <div className="page-home">
        <div className="container-fluid">
          <div className="row">
            <div className="col-4 p-0 d-none d-sm-none d-md-none d-lg-block position-relative">
              <ImageSidebar />
            </div>
            <div className="col-12 col-sm-12 col-md-12 col-lg-8 p-0">
              <div className="inner-home-page h-100">
                {!this.props.authenticator.isAuthentificated ? (
                  <Switch>
                    <Route path="/" exact={true} component={LoginPage} />
                    <Route path="/login" exact={true} component={LoginPage} />
                    <Route path="/reset-password" exact={true} component={ResetPasswordPage} />
                    <Route path="/reset-password/succeeded" exact={true} component={ResetPasswordSucceededPage} />
                    <Route path="/reset-password-change/succeeded" exact={true} component={ResetPasswordChangeSucceededPage} />
                    <Route path="/request-password-change" exact={true} component={ResetPasswordChangePage} />
                    <Route path="/register" exact={true} component={RegisterPage} />
                    <Route path="/register/succeeded" exact={true} component={RegisterSucceededPage} />
                    <Route path="/register/resend-activation/succeeded" exact={true} component={ResendSucceededPage} />
                    <Route path="/register/activate-account" exact={true} component={ActivateAccountPage} />
                    <Route path="/register/activate-account/succeeded" exact={true} component={ActivateAccountPage} />
                    <Route path="/imprint" exact={true} component={ImprintPage} />
                    <Route path="/legals" exact={true} component={LegalsPage} />
                    <Route path="/privacy-policy" exact={true} component={PrivacyPage} />
                    <Route path="/page-not-found" exact={true} component={PageNotFound} />
                  </Switch>
                ) : (
                  <Switch>
                    <Route path="/change-password/succeeded" exact={true} component={ChangePasswordSucceededPage} />
                    <Route path="/change-email/succeeded" exact={true} component={ChangeEmailSucceededPage} />
                    <Route path="/" exact={true} component={RegisterUserTestForm} />
                    <Route path="/page-not-found" exact={true} component={PageNotFound} />
                   
                  </Switch>
                )}
              </div>
              
              <div className="partial-footer fixed-bottom">
                <div className="container-fluid">
                  <div className="row">
                    <div className="col-12 col-12 col-lg-8 offset-lg-4 partial-meta">
                      {!this.props.authenticator.isAuthentificated && (
                        <ul className="p-0 text-center w-100">
                          <li className="d-inline pl-3 pr-3 small">
                            <Link to="/imprint">
                              <FormattedMessage {...MESSAGES.homeLinkImprint} />
                            </Link>
                          </li>
                          <li className="d-inline pl-3 pr-3 small">
                            <a href="https://kwc-professional.com/en_global/footer-pages/terms-and-conditions" target="_blank" 
                              onClick={(e) => {
                                e.preventDefault(); 
                                this.setState({showTerms: true})
                              }}>
                              <FormattedMessage {...MESSAGES.homeLinkLegals} />
                            </a>
                          </li>
                          <li className="d-inline pl-3 pr-3 small">
                            <a href="#privacy-policy" onClick={(e) => {
                              var button = (document as any).getElementById('usercentrics-root').shadowRoot.querySelector('[data-testid="uc-privacy-button"]');
                              button.click();
                              
                              e.preventDefault();
                              return false;
                            }}>
                              <FormattedMessage {...MESSAGES.homeLinkPrivacy} />
                            </a>
                          </li>
                        </ul>
                      )}
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
        {this.state.showTerms && (
          <TermsModal 
            drilledClose={() => {
              this.setState({showTerms: false});
            }}
          />
        )}
        {/* {authenticator.isAuthentificated && authenticator.accessToken && (
          <Redirect to={from || '/dashboard'} />
        )} */}
      </div>
    );
  }
}

interface State {
  authenticator: IsAuthentificatedState;
}

export const HomePage = connect((state: State) => ({
  authenticator: state.authenticator,
}))(HomePageComponent);

export default HomePage;
